import { useTranslation } from "react-i18next";
import { Sparkles, Clock, User } from "lucide-react";
import { useAuthSheet } from "@/auth/AuthSheetProvider";

const ProfilePrompt = ({ onLater }) => {
  // This prompt is shown to guests only, so it opens the sheet on its
  // create-account side rather than on sign-in.
  const { openRegister } = useAuthSheet();
  const { t } = useTranslation();
  return (
    <div
      data-testid="profile-prompt"
      className="rounded-3xl p-5 bg-neutral-900 text-white relative overflow-hidden mb-5"
    >
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{ backgroundImage: "radial-gradient(rgba(255,255,255,1) 1px, transparent 1px)", backgroundSize: "5px 5px" }}
      />
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-[#E34A27] flex items-center justify-center mb-3">
          <Sparkles size={20} className="text-white" />
        </div>
        <h3 className="text-xl font-black tracking-tight leading-tight whitespace-pre-line">
          {t("profilePrompt.title")}
        </h3>
        <ul className="mt-3 space-y-1.5 text-sm text-white/80">
          <li className="flex items-start gap-2">
            <Clock size={14} className="mt-0.5 shrink-0 text-[#E34A27]" />
            {t("profilePrompt.benefitOne")}
          </li>
          <li className="flex items-start gap-2">
            <User size={14} className="mt-0.5 shrink-0 text-[#E34A27]" />
            {t("profilePrompt.benefitTwo")}
          </li>
          <li className="flex items-start gap-2">
            <Sparkles size={14} className="mt-0.5 shrink-0 text-[#E34A27]" />
            {t("profilePrompt.benefitThree")}
          </li>
        </ul>
        <div className="grid grid-cols-2 gap-2 mt-5">
          <button
            data-testid="profile-prompt-create"
            onClick={openRegister}
            className="h-12 rounded-xl bg-[#E34A27] text-white font-bold text-sm active:scale-[0.98] transition-transform"
          >
            {t("profilePrompt.create")}
          </button>
          <button
            data-testid="profile-prompt-later"
            onClick={onLater}
            className="h-12 rounded-xl bg-white/10 text-white font-bold text-sm active:scale-[0.98] transition-transform"
          >
            {t("profilePrompt.later")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePrompt;
